export default {
  'background-color': {
    label: 'Background color',
    type: 'background-color',
    category: 'Section'
  },
  'background-image': {
    label: 'Background image',
    type: 'media-manager',
    category: 'Section',
    hint:
      'Set a background image for the section. It is recommended to use an image that has similar proportions to the section to avoid cropping.'
  },
  'background-image-tablet': {
    label: 'Background image (tablet)',
    type: 'media-manager',
    category: 'Section',
    showOn: {
      field: 'background-image',
      operator: 'notNull'
    },
    hint:
      'Set a background image for the section on tablet screen. If this is empty, "background image" will be used.'
  },
  'background-image-mobile': {
    label: 'Background image (mobile)',
    type: 'media-manager',
    category: 'Section',
    showOn: {
      field: 'background-image',
      operator: 'notNull'
    },
    hint:
      'Set a background image for the section on mobile screen. If this is empty, "background image (tablet)" or "background image" will be used.'
  },
  'parallax-background-image': {
    label: 'Parallax background image',
    type: 'toggle',
    category: 'Section',
    showOn: {
      field: 'background-image',
      operator: 'notNull'
    },
    hint:
      'Apply a parallax effect on the background image while scrolling.  It is recommended to use a background image with more height when parallax is enabled.'
  },
  'custom-padding': {
    label: 'Custom section padding',
    type: 'toggle',
    category: 'Section',
    hint:
      'Set custom top and bottom padding (spacing). When this is disabled, the default padding is controlled via the "Template settings" panel.'
  },
  'padding-top': {
    label: 'Padding top',
    type: 'slider',
    min: 0,
    max: 500,
    suffix: 'px',
    showOn: {
      field: 'custom-padding',
      operator: '==',
      value: '1'
    },
    category: 'Section'
  },
  'padding-bottom': {
    label: 'Padding bottom',
    type: 'slider',
    min: 0,
    max: 500,
    suffix: 'px',
    showOn: {
      field: 'custom-padding',
      operator: '==',
      value: '1'
    },
    category: 'Section'
  }
}
